import React from 'react';
import { Typography, Link } from '@mui/material';

export default function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'Copyright © '}
      {new Date().getFullYear()}
      {/* <Link color="inherit" href="https://appstar.zylascope.com">
        appstar.zylascope.com
      </Link> */}{' '}
      Geoff Williams AI Software
    </Typography>
  );
}